import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import { booleanCheckRenderer } from 'CMFW/grid/cellRenderers/booleanCheck';
import { IFields } from 'CMFW/grid/fields';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerRight,
  EditorRow,
  ModuleContainer,
} from 'components/common/styles';
import TextSearch from 'components/search/TextSearch';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import HanziModel from 'models/HanziModel';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import HanziCardItem from './HanziCardItem';

const cellRenderers = {
  [IFields.complete]: booleanCheckRenderer,
  [IFields.inStandard]: booleanCheckRenderer,
  [IFields.componentOnly]: booleanCheckRenderer,
};

const HanziCardsTab: React.FC = () => {
  const forceRender = useForceRender();
  const model = useMemo(() => new HanziModel({ render: forceRender, mode: 'cards' }), [forceRender]);
  const s = model.stats;

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={620}>
          <ContainerLeft>
            <TextSearch />
            {s && (
              <EditorRow>
                <StatsLine>
                  {s.cards} cards · {s.inStandard} standard · {s.componentOnly} component only · {s.incomplete}{' '}
                  incomplete · {s.synthetic} synthetic · {s.strokes} strokes ({s.strokesWithoutPiece} without piece) ·{' '}
                  {s.pieces} pieces ({s.piecesUnresolved} unresolved) · {s.componentsWithCard}/{s.components} GF
                  components with card
                </StatsLine>
              </EditorRow>
            )}
            <Grid cellRenderers={cellRenderers} />
            <ContainerLeftFooter>
              <ReloadButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <HanziCardItem />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

const StatsLine = styled.span`
  font-size: 12px;
  color: #757575;
`;

export default HanziCardsTab;
